import React, {useState} from 'react';
import {Logo} from "../icons";
import {Link} from "react-router-dom";
import {ALERT_TYPES, IUser, ROUTES} from "../../types";
import {BurgerMenu, Dropdown, Loader} from "../common";
import clsx from "clsx";
import {useQuery} from "react-query";
import {useAlert} from "../common/Alert";


const ClientNavbar = () => {
  const { setAlert } = useAlert()
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);
  const handleOpenMenu = () => setIsOpenMenu(true);
  const handleCloseMenu = () => setIsOpenMenu(false);

  const { data, error, isLoading }:
    {
      data: IUser | undefined;
      error?: any;
      isLoading: boolean;
    } = useQuery(["userInfo"], { refetchOnWindowFocus: false });

  if (error) {
    setAlert(error, ALERT_TYPES.ERROR);
  }

  return (
    <nav className="z-10 bg-yellow py-6 w-full">
      {isLoading && <Loader />}
      <div className="max-w-[1320px] px-4 flex items-center justify-between mx-auto">
        <BurgerMenu open={isOpenMenu} onClose={handleCloseMenu} isClientPage={true} />

        <div className={
            clsx(
              "hidden relative lg:block z-10",
              isOpenMenu && "lg:z-[-1]"
            )
          }
          onClick={handleOpenMenu}
        >
          <span className="bg-mainBlack w-[22px] h-[2px] block mb-[6px]" />
          <span className="bg-mainBlack w-[22px] h-[2px] block mb-[6px]" />
          <span className="bg-mainBlack w-[22px] h-[2px] block" />
        </div>

        <div className="flex items-center">
          <Link to={ROUTES.MAIN}><Logo /></Link>
          <Link to={ROUTES.APPLICATIONS} className="ml-8 mr-4 text-[16px] leading-[18px] font-medium text-black hover:opacity-60 duration-150 easy-in lg:hidden">
            Заявки
          </Link>
          <Link to={ROUTES.CLIENT_PRODUCT} className="text-[16px] leading-[18px] font-medium text-black hover:opacity-60 duration-150 easy-in lg:hidden">
            Продукты
          </Link>
        </div>

        <div className="flex items-center relative">
          <p className="text-mainBlack text-[14px] leading-[16px] pr-2 border-r border-r-solid border-r-mainBlack mr-[10px]">
            {data?.fio}
          </p>
          <Dropdown />
        </div>
      </div>
    </nav>
  )
};

export default ClientNavbar;
